import { create } from 'zustand'
import api from '../utils/api.js'

/** A plan row as returned by GET /plans. Loose boundary shape; quota bars read
 *  fields defensively, so only `name` (the map key) is required. */
export interface Plan {
  name: string
  [key: string]: unknown
}

/** GET /plans response payload. */
interface PlansResponse {
  plans?: Plan[]
}

export interface PlansState {
  plans: Plan[]
  /** name → plan row */
  planMap: Record<string, Plan>
  loaded: boolean
  fetchPlans: () => Promise<void>
  resetLoaded: () => void
}

const usePlansStore = create<PlansState>((set, get) => ({
  plans:   [],
  planMap: {}, // name → plan row
  loaded:  false,

  fetchPlans: async () => {
    if (get().loaded) return
    try {
      const { data } = await api.get<PlansResponse>('/plans')
      const plans   = data.plans || []
      const planMap = Object.fromEntries(plans.map(p => [p.name, p]))
      set({ plans, planMap, loaded: true })
    } catch {
      // Non-fatal — quota bars will just show nothing
    }
  },

  // Call on logout / tenant switch so stale plans don't block the next fetch.
  resetLoaded: () => set({ loaded: false }),
}))

export default usePlansStore
